import { render, staticRenderFns } from "./ProjectFolderView.vue?vue&type=template&id=78010ab6&"
import script from "./ProjectFolderView.vue?vue&type=script&lang=js&"
export * from "./ProjectFolderView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports